import { createFileRoute } from '@tanstack/react-router'
import EditPage from '@/features/scenic/scenic-areas/pages/edit'
import { detailQueryOptions } from '@/features/scenic/scenic-areas/query-options'

export const Route = createFileRoute(
  '/_authenticated/(scenic)/scenic-areas/$id/edit'
)({
  loader: async ({ context, params }) => {
    const { queryClient } = context
    await queryClient.ensureQueryData(
      detailQueryOptions({ detailKey: 'scenic-areas-detail', id: params.id })
    )
  },
  component: EditPage,
})
